module.exports = __webpack_public_path__ + "img/00.54bd33cb.jpg";